import './ServiceSection.css';

export default function ServiceSection({ title, description, features, image, reverse }) {
  return (
    <section className={`service-section ${reverse ? 'service-section--reverse' : ''}`}>
      <div className="service-visual">
        <div className="service-visual-card">
          <img src={image} alt={title} />
          <div className="service-visual-gradient"></div>
        </div>
      </div>
      <div className="service-copy">
        <span className="eyebrow">{title}</span>
        <h3>{title}</h3>
        <p>{description}</p>
        <ul className="service-features">
          {features.map((feature) => (
            <li key={feature}>{feature}</li>
          ))}
        </ul>
        <a className="button button-ghost" href="#contact">
          Explore this service
        </a>
      </div>
    </section>
  );
}
